"use strict";

export default {
  ANTRAG: "2ece5b25-e866-33c8-e050-007f01013bb8",
  ANTRAGSTELLER: "2ece5b25-e867-33c8-e050-007f01013bb8"
};
